import React, { ReactElement, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { getUrlParams } from '../helpers/urlHelper';
import { getUser } from '../main/store/User/actions/getUser';
import { getActiveProducts } from '../main/store/Products/actions/getActiveProducts';
import { getExtendedProducts } from '../main/store/Products/actions/getExtendedProducts';

export const useRefreshDataHOC = (Component: Function) => (props: any): ReactElement => {
    const location = useLocation();
    const dispatch = useDispatch();

    const endsWithSlash = /\/$/;

    const availableParams = {
        resultCode: 'resultCode',
    };

    useEffect(() => {
        if (location?.hash) {
            const queryString = getUrlParams(location.hash);
            const hasParams = !!queryString.get(availableParams.resultCode);

            if (hasParams) {
                dispatch(getUser());
                dispatch(getActiveProducts());
                dispatch(getExtendedProducts());
            }
        }
        if (!endsWithSlash.test(window.location.pathname)) {
            window.location.pathname += '/';
        }
    }, [location]);

    return <Component {...props} />;
};
